import { api } from "./paths";
import { NewPassword, UserEmail } from "../types/password";

const axios = require("axios");

export async function validateToken(token: string | null) {
  return axios.get(`${api.USERS_URL}/validate-request?token=${token}`);
}

export async function sendPasswordResetLink(email: UserEmail) {
  return axios.post(`${api.USERS_URL}/reset-password`, email);
}

export async function saveNewPassword(password: string, token: string | null) {
  const newPassword: NewPassword = {
    password,
    token,
  };
  return axios.post(`${api.USERS_URL}/save-password`, newPassword);
}
